import { sessionStorage } from 'app/services/storage';

import { TELEPHONY_API_ENDPOINT } from 'constants/api';
import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { getUUID } from 'utils/uuid';

const WEB_SESSION_ID_STORAGE_KEY = 'telnyxWebSessionId';

/**
 * Per-tab session id for the WebRTC credential mint. sessionStorage (not localStorage) so every
 * tab gets its own id and a duplicated tab never reuses another tab's live credential, while a
 * refresh of the SAME tab keeps reusing it — the backend sees one stable session across reloads.
 */
export const getOrCreateWebSessionId = () => {
  const existing = sessionStorage.getItem(WEB_SESSION_ID_STORAGE_KEY);

  if (existing) {
    return existing;
  }

  const sessionId = getUUID();

  sessionStorage.setItem(WEB_SESSION_ID_STORAGE_KEY, sessionId);

  return sessionId;
};

export const isHttpNotFound = error =>
  error?.response?.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND;

// DEV-6069: POST /api/telnyx/session responds with an envelope ({ jwt, sipUsername, expiresAt }),
// not a bare JWT string. Shared by the web (TelnyxProvider) and native (telephony.actions) mint
// paths so both unwrap the same way — a raw envelope object was previously stored/passed as the
// login token, which broke Telnyx auth. `token` is tolerated for a legacy `{ token }` envelope
// shape, and a bare string passes through unchanged (the legacy getTelnyxJwt / toggle-off response).
export const unwrapTelnyxCredentialJwt = data => data?.jwt ?? data?.token ?? data;

// TELEPHONY_API_ENDPOINT is unset in some test/local environments — tolerate that rather than
// throwing, matching the pre-fix template literal's ("undefined/api/...") non-throwing behavior.
const stripTrailingSlash = url => (url ?? '').replace(/\/+$/, '');

export const buildTelnyxSessionDeleteUrl = sessionId =>
  `${stripTrailingSlash(TELEPHONY_API_ENDPOINT)}/api/telnyx/session/${encodeURIComponent(
    sessionId,
  )}`;
